var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9.2,
    y1: 7,
    x2: 13,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.91,
    y1: 8.1,
    x2: 12.2,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1,
    y1: 8.91,
    x2: 10,
    y2: 12.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9.2,
    x2: 7,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.9,
    y1: 8.91,
    x2: 4,
    y2: 12.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.09,
    y1: 8.1,
    x2: 1.8,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.8,
    y1: 7,
    x2: 1,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.09,
    y1: 5.9,
    x2: 1.8,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.9,
    y1: 5.09,
    x2: 4,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4.8,
    x2: 7,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1,
    y1: 5.09,
    x2: 10,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.91,
    y1: 5.9,
    x2: 12.2,
    y2: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaude);
export default __webpack_public_path__ + "static/media/claude.82ba61b10960dbff711fa16f062d9dcf.svg";
export { ForwardRef as ReactComponent };